<template>
  <div v-if="canViewMenu()" class="top-menu">
    <nuxt-link :to="'/' + shopId" class="btn btn-default">{{ _('Sales') }}</nuxt-link>
    <nuxt-link :to="'/' + shopId + '/manage'" class="btn btn-default">{{ _('Manage') }}</nuxt-link>
    <nuxt-link :to="'/' + shopId + '/content'" class="btn btn-default">{{ _('Content') }}</nuxt-link>
    <nuxt-link :to="'/' + shopId + '/reports'" class="btn btn-default">{{ _('Reports') }}</nuxt-link>
    <nuxt-link :to="'/' + shopId + '/settings'" class="btn btn-default">{{ _('Settings') }}</nuxt-link>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['shopId', 'userData'])
  },
  methods: {
    canViewMenu () {
      if (this.userData && this.userData.userlevel == 10) {
        return true
      }
      return false
    },
    setView (view) {
      this.$store.dispatch('setView', view)
    }
  }
}
</script>

<style scoped>

.top-menu {
  position: fixed;
  top: 0; 
  right: 0;
}

</style>